import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ENTERPRISE_API_URL } from "../configs";
import { getJwtToken } from "../Util/localCache";

export const baseQueryWithAuth = (url) => {
  return fetchBaseQuery({
    baseUrl: url,
    prepareHeaders: (headers, { extraOptions }) => {
      headers.set("Content-type", "application/json");
      if (extraOptions?.auth) {
        const token = getJwtToken();
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });
};

const enterpriseApiSlice = createApi({
  reducerPath: "enterprieApi",
  baseQuery: baseQueryWithAuth(ENTERPRISE_API_URL),
  tagTypes: ["Cards", "Ach", "Charges", "Orders", "UserInvitations", "PaymentSources", "CompanyInfos", "Roles", "Billing", "MonthlyBilling", "CompanyAnalytics", "PerformanceReport"],
  endpoints: () => ({}),
});

export { enterpriseApiSlice };
